import component from './RecentCounterparties'

export default component
